import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnimateInDirective } from './animate-in.directive';
import { ObserverService, ObserverServiceConfig } from './observer.service';
export class AnimateInModule {
/**
 * @param {?} parentModule
 */
constructor(  parentModule: AnimateInModule) {
    if (parentModule) {
      throw new Error(
        'AnimateInModule is already loaded. Import it in the AppModule only'
      );
    }
  }
/**
 * @param {?=} config
 * @return {?}
 */
public static forRoot(config?: ObserverServiceConfig): ModuleWithProviders {
    return {
      ngModule: AnimateInModule,
      providers: [
        {
          provide: ObserverServiceConfig, useValue: config
        }
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
  ],
  exports: [
    AnimateInDirective,
  ],
  declarations: [
    AnimateInDirective
  ],
  providers: [
    ObserverService
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AnimateInModule, decorators: [{ type: Optional }, { type: SkipSelf }, ]},
];
}

function AnimateInModule_tsickle_Closure_declarations() {
/** @type {?} */
AnimateInModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AnimateInModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
